import Repository from './Repository';

const resource = '/arquivo';

export default {
  addImageProfile(payload) {
    return Repository.put(`${resource}/imagemPerfil`, payload);
  },
};
